import { resetMonthlyEntries } from '../timesheet/timesheetActions';

const CHANGE_DATE_OBJECT_ADD = 'CHANGE_DATE_OBJECT_ADD';
const CHANGE_DATE_OBJECT_SUBTRACT = 'CHANGE_DATE_OBJECT_SUBTRACT';

export const ADD = 'ADD';
export const SUBTRACT = 'SUBTRACT';

export const changeMonth = (op) => {
  return (dispatch) => {
    dispatch(resetMonthlyEntries());
    if (op === ADD) {
      dispatch({type: CHANGE_DATE_OBJECT_ADD});;
    }
    else if (op === SUBTRACT) {
      dispatch({type: CHANGE_DATE_OBJECT_SUBTRACT });
    }
  }
}